import { ListPagination, ResponseError } from '~/utils';
import request from '../request';

export const getClientAccount = async (
  document: string,
): Promise<AuditClientAccount> => {
  try {
    const { data } = await request.get(`/audit/${document}/info`);
    return data;
  } catch (error) {
    throw new ResponseError(error);
  }
};

export const getClientLogs = async (
  params: GetClientLogsParams,
): Promise<GetClientLogsResponse> => {
  try {
    const { document, page, size, ...queryParams } = params;
    const { data } = await request.get(`/audit/${document}/events`, {
      params: {
        ...queryParams,
        page: page ?? ListPagination.INITIAL_PAGE,
        size: size ?? ListPagination.SIZE,
      },
    });
    return data;
  } catch (error) {
    throw new ResponseError(error);
  }
};

export const downloadClientLogs = async (params: GetClientLogsParams) => {
  try {
    const { document, ...queryParams } = params;
    return request.get(`/audit/${document}/events/download`, {
      params: queryParams,
      responseType: 'blob',
    });
  } catch (error) {
    throw new ResponseError(error);
  }
};

export const downloadDetailedLog = async (
  params: DownloadDetailedLogParams,
) => {
  try {
    const { document, ...queryParams } = params;
    return request.get(`/audit/${document}/event/detail/download`, {
      params: queryParams,
      responseType: 'blob',
    });
  } catch (error) {
    throw new ResponseError(error);
  }
};
